import { render, staticRenderFns } from "./privateDetail.vue?vue&type=template&id=c6f803f6&"
import script from "./privateDetail.vue?vue&type=script&lang=js&"
export * from "./privateDetail.vue?vue&type=script&lang=js&"
import style0 from "./privateDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privateDetail.vue"
export default component.exports